import { Typography } from '@mui/material';

import { useTheme } from '@savvy/deprecated-shared/hooks/use-theme';
import { useModifiedStyleForWeb } from '@savvy/deprecated-shared/theme';

import type { XTypographyProps } from './types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME: This rule was recently enabled for the repo
export function XTypography({ children, href, ...props }: XTypographyProps) {
  const theme = useTheme();
  const style = useModifiedStyleForWeb(props.style);
  return (
    <Typography
      component="span"
      {...props}
      style={style}
      color={props.color === 'textCharcoal' ? theme.palette.text.charcoal : props.color}
    >
      {children}
    </Typography>
  );
}
